<template>
  <div class="h-screen flex flex-col justify-between bg-gray-50">
    <header
      class="w-full z-50 transition-all duration-300 bg-white-90 backdrop-blur-sm shadow-sm"
      id="navbar"
      data-ytoriginindex="0"
      data-ytindex="0"
      style="background-color: #ffffff"
    >
      <div
        class="container mx-auto px-4 sm:px-6 lg:px-8"
        data-ytextravalue="extra-kv0qketld"
      >
        <div
          class="flex justify-between items-center h-16 md:h-20"
          data-ytparentvalue="extra-kv0qketld"
          data-ytoriginindex="0"
          data-ytindex="0"
        >
          <!-- Logo -->
          <div class="flex items-center">
            <a
              class="flex items-center"
              href="javascript:void(0);"
              @click="toLandPage"
            >
              <div class="w-10 h-10 mr-3">
                <img :src="logo" alt="" />
              </div>
              <el-image
                style="width: 100px; height: 32px; margin-left: 10px"
                :src="logoTitle"
                fit="fill"
              ></el-image>
            </a>
          </div>
          <!-- 桌面导航 -->
          <nav class="hidden md:flex space-x-8">
            <a
              class="text-gray-600 hover:text-primary font-medium transition-colors"
              href="#features"
              data-yteditvalue
            >
            </a>
            <a
              class="text-gray-600 hover:text-primary font-medium transition-colors"
              href="#templates"
              data-yteditvalue
            >
            </a>
            <a
              class="text-gray-600 hover:text-primary font-medium transition-colors"
              href="#testimonials"
              data-yteditvalue
            >
            </a>
          </nav>
          <!-- 登录/注册按钮 -->
          <div class="hidden md:flex items-center space-x-4">
            <a
              class="bg-primary hover:bg-primary/90 text-white px-4 py-2 rounded-lg font-medium transition-colors shadow-sm hover:shadow"
              href="javascript:void(0);"
            >
              登录 / 注册
            </a>
          </div>
        </div>
      </div>
    </header>
    <div class="bg-gray-50 grow flex items-center justify-center">
      <div class="login-container bg-white rounded-lg shadow-lg flex">
        <div class="login-left relative overflow-hidden">
          <img :src="loginLogo" class="w-full h-full object-cover" />
          <!-- <div class="absolute bottom-4 left-4">
            <p class="text-white text-sm opacity-80">www.wenjuanjiajia.com</p>
          </div> -->
        </div>
        <div class="login-right flex flex-col items-center justify-center">
          <div class="flex items-center mb-8">
            <img
              src="https://ai-public.mastergo.com/ai/img_res/74a609ad167d4ed666fee0de9e2857c7.jpg"
              class="w-6 h-6 mr-2"
              alt="微信图标"
            />
            <span class="text-gray-700 text-lg">微信扫码登录</span>
          </div>
          <!-- 使用 ref 绑定二维码容器和刷新按钮 -->
          <div
            ref="xcxqrcode"
            class="qr-code-container bg-white p-4 rounded-lg mb-6"
          >
            <!-- 动态绑定二维码图片的 URL -->
            <img
              :src="qrCodeUrl"
              class="w-[180px] h-[180px]"
              alt="登录二维码"
            />
          </div>
          <!-- 修改为使用 @click 绑定方法 -->
          <div ref="wrpreloadbtn" class="wrpreloadbtn" @click="reloadPage">
            <img :src="require('@/assets/images/loginreload.png')" alt="" />
          </div>
          <p class="text-gray-500 text-sm">{{ message }}</p>
        </div>
      </div>
    </div>
    <footer
      class="w-full bg-dark text-gray-400 pt-8 pb-8 min-w-[1600px]"
      data-ytoriginindex="10"
      data-ytindex="11"
    >
      <div class="container mx-auto px-4 sm:px-6 lg:px-8 flex justify-between">
        <div class="flex">
          <div class="mr-48">
            <h4 class="text-white font-bold mb-12">快捷导航</h4>
            <ul class="space-y-2">
              <li class="mb-4 w-[180px]">
                <a
                  class="hover:text-white transition-colors"
                  href="javascript:void(0);"
                >
                  首页
                </a>
              </li>
              <li class="w-[180px]">
                <a
                  class="hover:text-white transition-colors"
                  href="javascript:void(0);"
                >
                  创建活动
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 class="text-white font-bold mb-12">联系我们</h4>
            <ul class="space-y-2">
              <li class="mb-4 w-[320px]">
                <a
                  class="hover:text-white transition-colors"
                  href="javascript:void(0);"
                >
                  电话：0451-84616340
                </a>
              </li>
              <li class="w-[320px]">
                <a
                  class="hover:text-white transition-colors"
                  href="javascript:void(0);"
                >
                  邮箱：huotoupiao@youzhiapp.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="flex justify-end">
          <div class="qr-popup mr-4">
            <img :src="miniProgramCode" alt="小程序二维码" />
            <p>打开小程序</p>
          </div>
          <div class="qr-popup">
            <img :src="kefuCode" alt="客服二维码" />
            <p>扫码联系客服</p>
          </div>
        </div> -->
      </div>
      <div class="container mx-auto lg:px-12 flex justify-between mt-8">
        <p>© {{ name }} {{ companyName }}</p>
        <p>{{ filing }}</p>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/utils/config";

export default {
  data() {
    return {
      qrCodeUrl: require("@/assets/images/qrcode.jpg"),
      loginKey: null,
      pollingInterval: null,
      token: null,
      message: "微信扫码一键登录",
      name: config.name,
      logo: config.logo,
      companyName: config.companyName,
      filing: config.filing,
      logoTitle: config.logoTitle,
      loginLogo: config.loginLogo,
      miniProgramCode: config.miniProgramCode,
      kefuCode: config.kefuCode,
    };
  },
  mounted() {
    this.getQrCode(); // 组件挂载后调用获取二维码的方法
  },
  methods: {
    async getQrCode() {
      try {
        const params = {
          // 这里添加你需要传递的参数
        };
        const response = await axios.post(
          `${process.env.API_BASE_URL}/PCwj/login`,
          params,
          {
            headers: {
              appId: this.$store.getters.getAppId,
            },
          }
        );
        if (response.data.code === 200) {
          // 将 Base64 数据转换为可以在 img 标签中使用的格式
          this.qrCodeUrl = `data:image/png;base64,${response.data.data.base64}`;
          this.loginKey = response.data.data.loginKey; // 保存 loginKey

          // 开始轮询检查登录状态
          this.pollingInterval = setInterval(async () => {
            try {
              const checkResponse = await axios.get(
                `${process.env.API_BASE_URL}/PCwj/checkLoginCode`,
                {
                  params: {
                    loginKey: this.loginKey,
                  },
                },
                {
                  headers: {
                    appId: this.$store.getters.getAppId,
                  },
                }
              );

              if (checkResponse.data.code === 200) {
                // 假设返回 code 200 且特定字段表示登录成功
                if (checkResponse.data.msg != "0") {
                  clearInterval(this.pollingInterval); // 停止轮询
                  console.log("用户已登录");
                  // 这里可以添加登录成功后的逻辑，如跳转到主页

                  let arr = checkResponse.data.msg.split(",");
                  this.token = arr[1];

                  // 分割
                  localStorage.setItem("token", this.token);
                  this.$router.push("/");
                  document.title = "问卷模板-" + config.title;
                  console.log("getItem:token", localStorage.getItem("token"));
                }
              } else if (checkResponse.data.code == 500) {
                clearInterval(this.pollingInterval); // 停止轮询
                // 使用 ref 获取 DOM 元素并修改样式
                if (this.$refs.xcxqrcode) {
                  this.$refs.xcxqrcode.style.filter = "blur(5px)";
                }
                if (this.$refs.wrpreloadbtn) {
                  this.$refs.wrpreloadbtn.style.display = "block";
                }
                this.message = "二维码已过期，请重新扫码";
              } else {
                console.error("检查登录状态失败:", checkResponse.data.msg);
              }
            } catch (error) {
              console.error("检查登录状态时出错:", error);
            }
          }, 3000); // 每 3 秒轮询一次
        } else {
          console.error("获取二维码失败:", response.data.msg);
        }
      } catch (error) {
        console.error("获取二维码失败:", error);
      }
    },
    beforeDestroy() {
      // 组件销毁时清除轮询
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
      }
    },
    // 添加 reloadPage 方法
    reloadPage() {
      window.location.reload();
    },
    // 跳转登录页
    toLandPage() {
      this.$router.replace("/");
    },
  },
};
</script>

<style scoped>
/* @import "../../assets/style/tailwind.css"; */

.w-\[180px\] {
  width: 180px;
}

.login-container {
  width: 800px;
  height: 420px;
}

.login-left {
  width: 310px;
  /* background: linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%); */
}

.login-right {
  width: 490px;
  padding: 40px;
  position: relative;
}

.qr-code-container {
  /* border: 1px solid #e5e7eb; */
}

.wrpreloadbtn {
  display: none;
  position: absolute;
  width: 99px;
  height: 32px;
  top: 52%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}

.qr-popup {
  background: white;
  padding: 10px;
  width: 120px;
  border-radius: 8px;
  text-align: center;
}

.qr-popup img {
  width: 100px;
  height: 100px;
}

.qr-popup p {
  font-size: 14px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/views/LoginPage/index.vue